import { IMember, IProject } from '../interfaces';
import { createReducer, on } from '@ngrx/store';
import {
  changeStatusMemberSuccess,
  getMembersSuccess,
  getProjectsSuccess,
  inviteMembersSuccess,
  removeMemberSuccess,
} from './access-settings.actions';

export interface IAccessSettingsState {
  count: number;
  list: IProject[];
}

const initialState: IAccessSettingsState = {
  count: 0,
  list: [],
};

export const accessSettingsReducer = createReducer(
  initialState,
  on(getProjectsSuccess, (state, { isShowMore, projects }) => {
    if (isShowMore) return { ...state, list: [...state.list, ...projects.list] };
    return { ...projects };
  }),
  on(getMembersSuccess, (state, { project }) => {
    const newList: IProject[] = state.list.map((oldProject: IProject) => {
      if (oldProject.id === project.id) return { ...oldProject, ...project };
      return oldProject;
    });
    return { ...state, list: newList };
  }),
  on(removeMemberSuccess, (state, { projectId, id, isMember }) => {
    const newList: IProject[] = state.list.map((oldProject: IProject) => {
      if (oldProject.id === projectId) {
        if (isMember) {
          const members: IMember[] | undefined = oldProject.members?.filter((member: IMember) => member.id === id);
          return { ...oldProject, members };
        } else {
          const members: IMember[] | undefined = oldProject.invited_members?.filter(
            (member: IMember) => member.id === id,
          );
          return { ...oldProject, invited_members: members };
        }
      }
      return oldProject;
    });
    return { ...state, list: newList };
  }),
  on(changeStatusMemberSuccess, (state, { projectId, id, active }) => {
    const newList: IProject[] = state.list.map((oldProject: IProject) => {
      if (oldProject.id === projectId) {
        const members: IMember[] | undefined = oldProject.members?.map((member: IMember) => {
          if (member.id === id) member.active = active;
          return member;
        });
        return { ...oldProject, members };
      }
      return oldProject;
    });
    return { ...state, list: newList };
  }),
  on(inviteMembersSuccess, (state, { countMembers, idProject }) => {
    const newList: IProject[] = state.list.map((oldProject: IProject) => {
      if (oldProject.id !== idProject) return oldProject;
      return { ...oldProject, all_members: oldProject.all_members + countMembers };
    });
    return { ...state, list: newList };
  }),
);
